var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      staticClass: "mainWrapper",
      attrs: { lg: 3, md: 4, sm: 6, xl: 1, xs: 8 }
    },
    [
      _c(
        "el-header",
        { staticStyle: { padding: "0" } },
        [
          _c("top-nav", {
            attrs: { gray: _vm.gray, privateMode: _vm.privateMode }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-main",
        { staticStyle: { padding: "0", overflow: "visible" } },
        [
          _c("reservation-form-section", {
            ref: "$reservationFormSectionRef",
            attrs: { "listing-details": this.item }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-footer",
        { staticStyle: { padding: "0" } },
        [
          _c("foot-nav", {
            attrs: { showQus: _vm.showFootTxt, privateMode: _vm.privateMode }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-767a8fb7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-767a8fb7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uConnectReservation/form/selectionFormLayout.vue
// module id = null
// module chunks = 